import UserCard from "./user-card";

export default UserCard;
